import { render } from "./Body.vue?vue&type=template&id=2882857f&scoped=true"
import script from "./Body.vue?vue&type=script&lang=js"
export * from "./Body.vue?vue&type=script&lang=js"

import "./Body.vue?vue&type=style&index=0&id=2882857f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2882857f"]])

export default __exports__